import dompurify from 'dompurify';
import { marked } from 'marked';

marked.setOptions({ gfm: true, breaks: false });

const ALLOWED_TAGS = [
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'p',
	'ul',
	'ol',
	'li',
	'strong',
	'em',
	'b',
	'i',
	'code',
	'pre',
	'a',
	'hr',
	'br',
	'blockquote',
];

/**
 * Render assistant Markdown to sanitized HTML using `marked` (correct ordered
 * numbering, nested lists, loose lists) styled by Tailwind `prose`. External
 * links get `target`/`rel` and a class (to escape the app's `a:not([class])`
 * default) without mutating the shared DOMPurify instance via global hooks.
 */
export function renderMarkdown(markdown: string): string {
	const raw = marked.parse(markdown ?? '', { async: false }) as string;
	const clean = dompurify.sanitize(raw, {
		ALLOWED_TAGS,
		ALLOWED_ATTR: ['href', 'start'],
	});
	return clean.replace(
		/<a\s+href=/g,
		'<a class="kb-link" target="_blank" rel="noreferrer noopener" href='
	);
}
